import { Modal, Text } from '@shopify/polaris';

export interface ConfirmDestructiveActionProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

export function ConfirmDestructiveAction({
  open,
  title,
  message,
  confirmLabel = 'Delete',
  onConfirm,
  onCancel,
  loading,
}: ConfirmDestructiveActionProps): JSX.Element {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      primaryAction={{
        content: confirmLabel,
        destructive: true,
        onAction: onConfirm,
        loading,
      }}
      secondaryActions={[{ content: 'Cancel', onAction: onCancel, disabled: loading }]}
    >
      <Modal.Section>
        <Text as="p" variant="bodyMd">{message}</Text>
      </Modal.Section>
    </Modal>
  );
}
